



























































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { BookingListModule } from "@/store/modules/bookingList";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import { AgencySettingsModule } from "@/store/modules/agencySettings";

@Component({
  name: "BookingListSearchCriteria",
})
export default class extends GiganautVueDialog {
  public dialog = false;
  public locationSearch: any = null;
  public datesFailedValidation = false;

  allowedDates(date: Date) {
    return new Date(date).getDay() === 1;
  }

  get searchOptions() {
    return BookingListModule.bookingSearchViewModel;
  }

  get branches() {
    return AgencySettingsModule.branches;
  }

  get loading() {
    return BookingListModule.loading;
  }

  async search() {
     if (BookingListModule.bookingSearchViewModel.startAtFrom === undefined) {
      this.datesFailedValidation = true;
      return;
    }
    this.dialog = false;
    await BookingListModule.searchBookings();
  }
}
